import React from 'react'
import { useModal } from '../../hooks/modal'
import { useDeleteRequest } from '../../hooks/request'
import { CONTRACT_DETAIL } from '../../urls'
import ContractUpdate from './ContractUpdate'
import Button from '../../components/common/Button'

export default function ContractItem({ item, contract, index }) {
    const productRemove = useDeleteRequest({ url: CONTRACT_DETAIL.replace('{id}', item.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            contract.request()
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <ContractUpdate
            clients={contract}
            item={item}
            onCancel={() => {
                contract.request()
                hideUpdateModal()
            }}
        />,
    )

    return (
        <tr className=" is-size-6" key={item.id}>
            <td className="is-size-6">{index + 1}</td>
            <td className="is-size-6">{item.selectCustomer?.fullName}</td>
            <td className="is-size-6">{item.selectApartment?.apartmentNumber} - Хона</td>
            <td className="is-size-6">{(item.startDate)}</td>
            <td className="is-size-6">{(item.endDate)}</td>
            <td className="is-size-6">{(item.remainingAmount)} Сўм</td>
            <td>
                <div style={{ display: 'flex' }} className="has-text-right">
                    <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small"
                        icon="pencil-outline" />
                    <Button onClick={onDelete} className="button is-danger mr-2 is-outlined is-small" icon="trash" />
                </div>
            </td>
        </tr>

    )
}
